import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Navbar from "./layout/Navbar";
import Home from "./components/home/Home";
import Loader from "./common/Loader";
import About from "./components/about/About";
import Footer from "./layout/Footer";
import Speciality from "./components/specialities/Speciality";
import Appointment from "./components/appointment/Appointment";
import ContactUs from "./components/contactUs/ContactUs";
import TermsAndConditions from "./components/termsAndConditions/Terms";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import ErrorPage from "./layout/ErrorPage";

import "./css/animate.css";
import "./css/bootstrap.min.css";
import "./css/flaticon.css";
import "./css/font-awesome.css";
import "./css/main.css";
import "./css/megamenu.css";
// import "./css/prettyPhoto.css";
import "./css/shortcodes.css";
import "./css/responsive.css";
import "./css/slick.css";
import "./css/themify-icons.css";
import "./css/twentytwenty.css";
import "./css/index.css";
import ScrollToTop from "./common/ScrollToTop";
import { ToastContainer } from "react-toastify";
import TeamDetails from "./components/about/TeamDetails";
import PopupModal from "./components/home/PopupModal";
import { fetchCsrfToken } from "./apis/Interceptor";
import BlogDetails from "./components/blog/BlogDetails";
import Blog from "./components/blog/Blog";

function App() {
  const [showLoader, setShowLoader] = useState(true);
  const [tab, setTab] = useState("home");
  const [specialityId, setSpecialityId] = useState("");

  const csrfFetchedRef = useRef(false);

  useEffect(() => {
    if (!csrfFetchedRef.current) {
      fetchCsrfToken();
      csrfFetchedRef.current = true;
    }
    setTimeout(() => {
      setShowLoader(false);
    }, 5);
  }, []);
  return (
    <Router>
      <div className="page">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {showLoader && <Loader />}
        <PopupModal setTab={setTab} />
        <Navbar
          tab={tab}
          setTab={setTab}
          specialityId={specialityId}
          setSpecialityId={setSpecialityId}
        />
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Home setTab={setTab} />} />
          <Route exact path="/about" element={<About setTab={setTab} />} />
          <Route
            exact
            path="/specialities/:specialityId"
            element={<Speciality setTab={setTab} />}
          />
          <Route
            exact
            path="/about/:doctorId"
            element={<TeamDetails setTab={setTab} />}
          />
          <Route
            exact
            path="/appointment"
            element={<Appointment setTab={setTab} />}
          />
          <Route exact path="/blogs" element={<Blog setTab={setTab} />} />
          <Route
            exact
            path="/blogs/:id"
            element={<BlogDetails setTab={setTab} />}
          />
          <Route
            exact
            path="/contactus"
            element={<ContactUs setTab={setTab} />}
          />
          <Route
            exact
            path="/t&c"
            element={<TermsAndConditions setTab={setTab} />}
          />
          <Route
            exact
            path="/privacypolicy"
            element={<PrivacyPolicy setTab={setTab} />}
          />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <Link
          to="https://wa.me/7970479666"
          target="_blank"
          className="whatsapp-container"
        >
          <i className="fa fa-whatsapp"></i>
        </Link>
        <Footer
          setTab={setTab}
          specialityId={specialityId}
          setSpecialityId={setSpecialityId}
        />
      </div>
    </Router>
  );
}

export default App;
